<template>
	<div style="min-height: 100%; width: 100%;">
		<div class="host-info-header bg-min-height">
			<div class="host-info-header__gradient" style="z-index: 1;">
				<div class="host-info-header__scroll-icon"><button type="button" @click="scrollDownPage"><i class="fas fa-chevron-down"></i></button></div>
				<v-container fill-height fluid class="pa-0">
					<v-layout row wrap align-center hidden-sm-and-down>
						<v-flex md4 offset-md2 sm4 offset-sm1>
							<h1 class="host-info-header-1">
								Host<img src="/static/images/color-white-host.svg" height="40px" width="40px" style="margin-bottom: 70px;">
							</h1>
							<p class="host-info-sub-header-1">
								Share.&nbsp;&nbsp;Earn.&nbsp;&nbsp;Discover.
							</p>
						</v-flex>
						<v-flex sm3 offset-sm1>
							<h4 class="host-info-header-2" style="margin-top: 50px;">
								Create and publish a <span class="host-info-bold-larger">wrkprty</span><br>
								of your very own.
							</h4>
							<router-link class="pa-3 mt-5 host-info-header-button-1" :to="{name: 'host_apply'}">Get started</router-link>
						</v-flex>
					</v-layout>
					<v-layout row wrap align-center hidden-md-and-up>
						<v-flex md5 offset-md2 xs10 offset-xs1>
							<div style="width: 100%" class="mb-5">
								<h1 class="host-info-header-1-mobile mb-2">
									Host
								</h1>
								<p class="host-info-sub-header-1-mobile">
									Share. Earn. Discover.
								</p>
							</div>
							<h4 class="host-info-header-2-mobile" style="margin-top: 10vh">
								Create and publish a <span class="host-info-bold-larger">wrkprty</span> of your very own.
							</h4>
							<router-link class="pa-3 mt-5 host-info-header-button-1" :to="{name: 'host_apply'}">Get started</router-link>
						</v-flex>
					</v-layout>
				</v-container>
			</div>
		</div>
		<v-container fluid class="content-pad-vert pb-0">
			<v-layout row wrap>	
				<div class="host-info-body row wrap" style="flex: 1 1 auto">
					<v-flex xs10 md6 offset-md3 offset-xs1 id="host-info-content" class="pa-3">
						<h4 class="host-info-header-3 mt-5 mb-4">Why Host?</h4>
						<p class="host-info-content mt-3">Hosting a wrkprty is a great way to start a vibrant community in your area. So many people working from home want opportunities to connect; <strong>wrkprty hosts</strong> give people the chance to work together in unique spaces. It’s real connection and a formula for increased productivity.</p>
						<br>
						<h4 class="host-info-header-3">Wondering how to do it?</h4>
						<p class="host-info-content" style="text-align: center;">Offering  a wrkprty, or other related event, is <span class="host-info-bold">easy as...</span></p>
						<br>
						<div style="display: flex; flex-direction: column;">
							<div style="display: flex; flex-direction: row; justify-content: space-between; align-content: center;">
								<div>
									<h1 class="host-apply-number-headers">1.</h1>
								</div>
								<div class="pl-4">
									<h4 class="host-info-header-5">Become a Host</h4>
									<p class="host-info-content">To kick things off, we’ll just need your phone number and location information so we can help support you (and to pay you).</p>
								</div>
							</div>
							<div style="display: flex; flex-direction: row; justify-content: space-between; align-content: center;">
								<div>
									<h1 class="host-apply-number-headers">2.</h1>
								</div>
								<div class="pl-4">
									<h4 class="host-info-header-5">Post your Event</h4>
									<p class="host-info-content">Once you’re a host, you can add your own event(s). From type (e.g. coworking event or workshop) to price and more, you’re in control of the experience and access.</p>
								</div>
							</div>
							<div style="display: flex; flex-direction: row; justify-content: space-between; align-content: center;">
								<div>
									<h1 class="host-apply-number-headers">3.</h1>
								</div>
								<div class="pl-4">
									<h4 class="host-info-header-5">That’s it!</h4>
									<p class="host-info-content">You are now ready to experience the joy and benefits of meeting and working alongside other incredible like-minded professionals!</p>
								</div>
							</div>
							<!-- <v-flex xs3>
								<h1 class="host-apply-number-headers">2.</h1>
							</v-flex>
							<v-flex xs9 class="pl-4">
								<h4 class="host-info-header-5">Post your Event</h4>
								<p class="host-info-content">Once you’re a host, you can add your own event(s). From type (e.g. coworking event or workshop) to price and more, you’re in control of the experience and access.</p>
							</v-flex>
							<v-flex xs3>
								<h1 class="host-apply-number-headers">3.</h1>
							</v-flex>
							<v-flex xs9 class="pl-4">
								<h4 class="host-info-header-5">That’s it!</h4>
								<p class="host-info-content">You are now ready to experience the joy and benefits of meeting and working alongside other incredible like-minded professionals!</p>
							</v-flex> -->
						</div>
					</v-flex>
					<!-- <v-flex xs10 md8 offset-md2 class="mt-5 hidden-sm-and-up text-xs-center" offset-xs1>
						<div style="width: 100%">
							<p class="host-info-blue">productivity</p>
							<p class="host-info-green">connection</p>
							<p class="host-info-yellow">opportunity</p>
							<p class="host-info-orange">happiness</p>
							<p class="host-info-red">fast</p>
						</div>
					</v-flex> -->
					<v-flex xs10 md8 offset-md2 class="mt-5 hidden-xs-only" offset-xs1>
						<div class="host-info-stretch">
							<span class="host-info-blue">productivity</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="host-info-green">connection</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="host-info-yellow">opportunity</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="host-info-orange">happiness</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="host-info-red">fast</span>
						</div>
					</v-flex>
					<v-flex xs10 md8 offset-md2 offset-xs1 class="mt-5">
						<div class="host-info-header-4 mb-5">What to Expect...</div>
						<v-layout row hidden-xs-only class="mb-5">
							<div class="mr-5" style="width: 500px">
								<v-card>
									<v-card-media src="/static/images/host-info-2.jpg" height="300px" width="300px">
									</v-card-media>
								</v-card>
							</div>
							<v-flex md7 xs12 class="mt-2">
								<p class="host-info-header-small">Great people, Safety, and Support</p>
								<p class="host-info-content">WRKPRTY users are vetted and rated by other users, so you can feel comfortable knowing everyone you approve understands their own responsibilities as a guest in your space. And our team will always be on-hand to support you every step of the way!</p>
							</v-flex>
						</v-layout>
						<v-layout row class="mt-5" hidden-xs-only>
							<v-flex xs12 md7 class="mt-2">
								<p class="host-info-header-small">Designed to be Easy &amp; Flexible</p>
								<p class="host-info-content">The WRKPRTY system is designed for your ease of use. We want you to have the best workday ever when you host. To make it easier and more flexible for you, we’ve put the control in your hands and provide you all the tools and steps needed to make your WRKPRTY a SUCCESS!</p>
							</v-flex>
							<div class="ml-5" style="width: 500px">
								<v-card>
									<v-card-media src="/static/images/host-info-1.jpg" height="300px" width="300px">
									</v-card-media>
								</v-card>
							</div>
						</v-layout>
						<v-layout row wrap hidden-sm-and-up justify-center class="mb-5">
							<div style="width: 100%">
								<v-card>
									<v-card-media src="/static/images/host-info-2.jpg" height="200px">
									</v-card-media>
								</v-card>
							</div>
							<v-flex md6 xs12 class="mt-4">
								<p class="host-info-header-small">Great people, Safety, and Support</p>
								<p class="host-info-content">WRKPRTY users are vetted and rated by other users, so you can feel comfortable knowing everyone you approve understands their own responsibilities as a guest in your space. And our team will always be on-hand to support you every step of the way!</p>
							</v-flex>
						</v-layout>
						<v-layout row wrap class="mt-5" hidden-sm-and-up justify-center>
							<div style="width: 100%">
								<v-card>
									<v-card-media src="/static/images/host-info-1.jpg" height="200px">
									</v-card-media>
								</v-card>
							</div>
							<v-flex xs12 md6 class="mt-4">
								<p class="host-info-header-small">Designed to be Easy &amp; Flexible</p>
								<p class="host-info-content">The WRKPRTY system is designed for your ease of use. We want you to have the best workday ever when you host. To make it easier and more flexible for you, we’ve put the control in your hands and provide you all the tools and steps needed to make your WRKPRTY a SUCCESS!</p>
							</v-flex>
						</v-layout>
					</v-flex>
					<div class="host-info__bottom-fullscreen-image mt-5">
						<div class="host-info__bottom-fullscreen-image__gradient" style="z-index: 1;">
						<v-layout row wrap>
							<v-flex md5 offset-md3 sm5 offset-sm2 xs8 offset-xs1 style="margin-top: 25vh">
								<h1 class="host-info-header-bottom mb-3">
									The RULES<br>
									have changed.
								</h1>
								<p class="host-info-content-bottom mb-1">You don't need an office.</p>
								<p class="host-info-content-bottom mb-1">You don't need a coffee shop.</p>
								<p class="host-info-content-bottom mb-1">You don't need to work all alone...</p>
								<router-link style="margin-left: 12vw; margin-top: 25px; width: 250px!important;" class="hidden-xs-only pa-3 mt-5 host-info-header-button-1" :to="{name: 'host_apply'}">Get started</router-link>
							</v-flex>
							<v-flex xs10 offset-xs1 class="hidden-sm-and-up">
								<router-link style="margin-top: 35px;" class="hidden-sm-and-up pa-3 mt-5 host-info-header-button-1" :to="{name: 'host_apply'}">Get started</router-link>
							</v-flex>
						</v-layout>
						</div>
					</div>
				</div>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
import axios from 'axios'
import { baseURL } from '~/store/util/values.js'
export default {
	middleware: 'requireAuth',
	$validates: true,
	data() {
		return {
			name: '',
			email: '',
			phone: '',
			city: '',
			message: '',
			valid: false,
			nameRules: [
				v => !!v || 'Name is required',
				v => v.length <= 20 || 'Name must be less than 20 characters'
			],
			// emailRules: [
			// 	(v) => !!v || 'E-mail is required',
			// 	(v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(v) || 'E-mail must be valid'
			// ],
			phoneRules: [
				v =>
					/(\+?\d{1,2}\s?.?-?)?\(?\d{3}\)?[\s-.]?\d{3}[\s-.]?\d{4}\b/.test(v) ||
					'Please enter a valid phone'
			],
			// cityRules: [
			// 	(v) => v.length <= 20 || 'City must be less than 20 characters'
			// ]
			window: {
				static_url: window.static_url
			}
		}
	},
	methods: {
		scrollDownPage() {
			// window.scrollTo(0, 200)
			document.querySelector('#host-info-content').scrollIntoView({
				behavior: 'smooth'
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@keyframes float {
	from {
		bottom: 10px;
	}
	to {
		bottom: 20px;
	}
}

.host-info-header__scroll-icon {
	position: absolute;
	bottom: 5px;
	left: 50%;
	margin-left: -18px;
	animation: float 2s ease-in-out infinite alternate;
	button {
		outline: 0;
	}
	i {
		color: #666;
		font-size: 3em;
	}
}

.bg-min-height {
	height: 100%;
	min-height: 100vh;
}

.host-info__bottom-fullscreen-image {
	background-image: url('https://wrkprty.imgix.net/backgrounds/host-info-girl-computer.jpg?q=65&w=1600');
	-webkit-background-size: cover;
	-moz-background-size: cover;
	-o-background-size: cover;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	height: 100vh;
	width: 100%;
	position: relative;
	&__gradient {
		position: absolute;
		top: 0px;
		left: 0px;
		opacity: 1.0;
		z-index: 1;
		width: 100%;
		/*height: 150px;*/
		height: 100%;
		background: linear-gradient(
			to bottom,
			rgba(255, 255, 255, 1) 0%,
			rgba(255, 255, 255, 0.95) 5%,
			rgba(255, 255, 255, 0.9) 10%,
			rgba(255, 255, 255, 0) 60%
		);
	}
}

.host-info-header {
	background-image: url('https://wrkprty.imgix.net/backgrounds/host-info-handshake.jpg?q=65&exp=-10&w=1600');
	-webkit-background-size: cover;
	-moz-background-size: cover;
	-o-background-size: cover;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	position: absolute;
	left: 0;
	top: 0;

	width: 100vw;
	height: 450px;
	&__gradient {
		position: absolute;
		top: 0px;
		left: 0px;
		opacity: 0.99;
		z-index: 1;
		width: 100%;
		/*height: 150px;*/
		height: 100%;
		background: linear-gradient(
			to bottom,
			rgba(0, 0, 0, 0.3) 0%,
			rgba(0, 0, 0, 0) 15%,
			rgba(255, 255, 255, 0) 70%,
			rgba(255, 255, 255, 1) 100%
		);
	}
}
</style>
